import React from 'react';
import { IconBuilding, IconCar, IconChevronRight, IconLogo, IconNavigate, IconSparkles } from '../ui/icons';

// Customer is anonymous-only via the chat (no login), so dev mode only simulates the authenticated
// Cognito GROUPS. `operations` = R3 ops; `peoria_operations` = the Peoria charter dashboard (a
// DISTINCT group — the two products' logins don't cross over). `ecap` is a dev shortcut that opens the
// ECAP flow-automation dashboard directly (App.js maps it to the ops surface on the Automation page).
// `r3_admin` previews an R3 company administrator: lands on /r3ops.
const ROLES = [
  { id: 'ecap',               label: 'Movorra ECAP',      desc: 'No-code conversational flow automation', icon: IconSparkles },
  { id: 'r3_admin',           label: 'Company Admin (R3)', desc: 'R3 operations dashboard + dispatch', icon: IconBuilding },
  { id: 'driver',             label: 'Driver (R3)',       desc: 'GPS tracking, trips, earnings',          icon: IconCar },
  { id: 'operations',         label: 'Operations (R3)',   desc: 'R3 dispatch board, driver map',          icon: IconNavigate },
  { id: 'peoria_operations',  label: 'Operations (Peoria)', desc: 'Peoria charter quote-requests board',  icon: IconNavigate },
  { id: 'krapf_operations',   label: 'Operations (Krapf)', desc: 'Krapf charter inquiry inbox',           icon: IconSparkles },
];

function AdminPage({ onSelectRole }) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center px-4 py-10 bg-slate-50">
      <div className="w-full max-w-md bg-white rounded-xl border border-slate-200 shadow-sm p-6 space-y-6">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-indigo-600 text-white mb-3">
            <IconLogo size={24} />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Movorra</h1>
          <p className="text-sm text-slate-500 mt-1">Dev mode — select a role to preview</p>
        </div>

        <div className="space-y-3">
          {ROLES.map((role) => {
            const Icon = role.icon;
            return (
              <button
                key={role.id}
                type="button"
                onClick={() => onSelectRole(role.id)}
                className="group w-full flex items-center gap-4 p-5 bg-white rounded-xl border border-slate-200 shadow-sm
                  hover:shadow-md hover:border-indigo-300 transition-all duration-150 cursor-pointer text-left
                  focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-150">
                  <Icon size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-lg font-semibold text-slate-800">{role.label}</div>
                  <div className="text-sm text-slate-600 leading-relaxed mt-0.5">{role.desc}</div>
                </div>
                <IconChevronRight size={18} className="text-slate-400 group-hover:text-indigo-600 transition-colors" />
              </button>
            );
          })}
        </div>

        <p className="text-xs text-slate-500 text-center">No login required. Uses mock session data.</p>
      </div>
    </div>
  );
}

export default AdminPage;
